export default function SupportIco() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4523_38549)">
        <path
          d="M10.5 6.0003H9.5C8.94772 6.0003 8.5 6.44802 8.5 7.0003V8.0003C8.5 8.55259 8.94772 9.0003 9.5 9.0003C10.0523 9.0003 10.5 8.55259 10.5 8.0003V6.0003ZM10.5 6.0003C10.5 3.51502 8.48528 1.50031 6 1.50031C3.51472 1.50031 1.5 3.51502 1.5 6.0003M1.5 6.0003V8.0003C1.5 8.55259 1.94772 9.0003 2.5 9.0003C3.05228 9.0003 3.5 8.55259 3.5 8.0003V7.0003C3.5 6.44802 3.05228 6.0003 2.5 6.0003H1.5Z"
          stroke="#F79009"
          stroke-width="1.11111"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.5 7.00006V9.00006C10.5 10.0001 10.1667 10.5001 9.5 10.5001C8.83333 10.5001 8 10.5001 7 10.5001"
          stroke="#F79009"
          stroke-width="1.11111"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4523_38549">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
